<script setup>
import {computed, ref} from 'vue';
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";
import EditableResourceImageField
    from "../../../../portal-editable-fields/resources/EditableResourceImageField.vue";
import EditableTextField from "../../../../portal-editable-fields/EditableTextField.vue";
import EditableResourceTextEditorField
    from "../../../../portal-editable-fields/resources/EditableResourceTextEditorField.vue";
import EditableResourceButtonField
    from "../../../../portal-editable-fields/resources/EditableResourceButtonField.vue";

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
});

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const cornerClass = computed(() =>
    portalContentAndDesignStore.portalLayoutSettings.referral_portal_content_layout_corners || 'rounded-xl'
);

const hoverMainContentCtaContainer = ref(false);

</script>

<template>
    <div>
        <div class="flex justify-start items-center gap-6"
             @mouseenter="hoverMainContentCtaContainer = true"
             @mouseleave="hoverMainContentCtaContainer = false"
             :id="resource.unique_id"
        >
                <editable-resource-image-field
                    resource-image-path="main_image"
                    :resource-content="resource"
                    :img-class="resource.main_image_retina_resize ? 'max-w-8' : 'flex-1 max-w-16'"
                    img-name="main_image"
                    :show-add-image-button="hoverMainContentCtaContainer"
                />

                <div class="space-y-2">
                    <editable-text-field
                        text-type="custom"
                        :class="['text-lg md:text-2xl font-semibold', portalContentAndDesignStore.getPageContentTextColorClass]"
                        v-model="resource.title"
                    />
                    <editable-resource-text-editor-field
                        :class="[
                        'partnero-page-content-section text-md md:text-lg text-opacity-80 space-y-1',
                        portalContentAndDesignStore.getPageContentTextColorClass
                    ]"
                        :resource="resource"
                        resource-field="description"
                    />
                </div>
            </div>

        <template v-if="resource.contents?.length">
            <div
                :class="[
                  (resource.title || resource.description) ? 'mt-6' : '',
                  'grid gap-6',
                  resource.display_content
                    ? `md:gap-12 md:grid-cols-${resource.contents.length > 3 ? 3 : resource.contents.length}`
                    : ''
                ]"
            >
                <div
                    v-for="content in resource.contents"
                    :key="content.unique_id"
                    class="flex flex-col items-start space-y-4"
                >
                    <editable-resource-button-field
                        :resource-content="content"
                        type="primary"
                        size="large"
                        :class="[resource.display_content ? 'w-full' : '', portalContentAndDesignStore.getPageContentLayoutCornerClass]"
                    />
                </div>
            </div>
        </template>
    </div>
</template>
